import type { MenuItem } from 'primereact/menuitem'
import { useMsal } from '@azure/msal-react'
import { Menubar } from 'primereact/menubar'
import { signOutClickHandler } from './signOut'
import { userMenuTexts } from './texts'
import styles from './UserMenu.module.css'

export function UserMenu() {
  const { instance } = useMsal()
  const activeAccount = instance.getActiveAccount()

  if (!activeAccount) {
    return null
  }

  const userId = activeAccount.homeAccountId
  const model: MenuItem[] = [
    {
      label: activeAccount.name ?? activeAccount.username,
      icon: 'pi pi-user',
      items: [
        {
          label: userMenuTexts.logout,
          icon: 'pi pi-sign-out',
          command: () => {
            void signOutClickHandler(instance, userId)
          },
        },
      ],
    },
  ]

  return (
    <Menubar model={model} className={`bg-white p-0 border-none hover:text-white hover:text-cyan-500 ${styles.userMenu}`} />
  )
}
